<template>
  <div class="simple-header">
    <img  @click="goHome" :src="icon" height="50px" width="50px" />
    <h3 @click="goHome">怀真 CMS</h3>
  </div>
</template>

<script>
import commonComputeds from "@/utils/commonComputeds";

export default {
  name: "my-simple-header",
  computed: {
    ...commonComputeds,
  },
  methods: {
    goHome() {
      this.$router.push("/").catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.simple-header {
  display: flex;
  align-items: center;
  width: 15%;
  img {
    margin-right: 1rem;
    cursor: pointer;
  }

  h3 {
    margin: 0px;
    cursor: pointer;
  }
}
</style>